import type { SVGProps } from "react";
import * as React from "react";

const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m3 9-.614-.79A1 1 0 0 0 2 9zm9-7 .614-.79a1 1 0 0 0-1.228 0zm9 7h1a1 1 0 0 0-.386-.79zM3 20H2zm5 2a1 1 0 1 0 2 0zm1-10v-1a1 1 0 0 0-1 1zm6 0h1a1 1 0 0 0-1-1zm-1 10a1 1 0 1 0 2 0zM3.614 9.79l9-7-1.228-1.58-9 7zm7.772-7 9 7 1.228-1.58-9-7zM20 9v11h2V9zm0 11a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 20zm-.293.707A1 1 0 0 1 19 21v2a3 3 0 0 0 2.121-.879zM19 21H5v2h14zM5 21a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 23zm-.707-.293A1 1 0 0 1 4 20H2a3 3 0 0 0 .879 2.121zM4 20V9H2v11zm6 2V12H8v10zm-1-9h6v-2H9zm5-1v10h2V12z"
    />
  </svg>
);
export default SvgHome;
